jQuery(document).foundation();


jQuery(document).ready(function($) {
	
/* PREVENT EMPTY SEARCH
------------------------------------*/
	$('#search-form').bind('submit', function(){
		if( $(this).find('input[type="text"]').val() === '' )
		return false;
	});


/* REMOVE USELESS EMPTY P IN ACCORDION
------------------------------------*/
    $('.accordion p:empty, .orbit p:empty').remove();
	
	
/* STICKY MAIN
------------------------------------*/
	if( $('body:not(.mobile) main').height() < $(window).height()){
		$('body:not(.mobile) main').css('min-height', $(window).height() - $('footer#footer').innerHeight() - $('header#header').innerHeight() + 2);
	}
	
	
/* GO TOP
------------------------------------*/
	$('#go-top').on('click', function() {
        $('html,body').animate({ scrollTop: 0 }, 700);
        return false;
    });
	
});
 